import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Tab, TAB_SIZES, TAB_UNDERLINE_SIZES } from '@design-system/tab';
export const TabsList = ({ mt = 2, size = TAB_SIZES.normal, tabs = [], tabsPosition = 'flex-start', underlineSpacingSize = TAB_UNDERLINE_SIZES.NORMAL, }) => (_jsx(TabsListWrapper, { "$tabsPosition": tabsPosition, role: "navigation", children: _jsx(StyledTabsList, { as: "ul", mt: mt, children: tabs.map(({ active, dataTestId, disabled, dot, label, onClickAction, path }, index) => (_jsx(StyledTab, { as: "li", children: _jsx(Tab, { active: active, dataTestId: dataTestId, disabled: disabled, dot: dot, label: label, onClickAction: onClickAction, path: path, size: size, underlineSpacingSize: underlineSpacingSize }) }, path !== null && path !== void 0 ? path : index))) }) }));
const TabsListWrapper = styled(Box).attrs(({ $tabsPosition }) => ({
    justifyContent: $tabsPosition,
})) ``;
const StyledTabsList = styled(Box).attrs(() => ({
    flexWrap: 'wrap',
    mb: 0,
    p: 0,
})) ``;
const StyledTab = styled(Box).attrs(() => ({
    minHeight: '26px',
    mr: 6,
    mt: 3,
})) ``;
//# sourceMappingURL=TabsList.js.map